// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fallback-page {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/datalens/pages/FallbackPage/FallbackPage.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;AACJ","sourcesContent":[".fallback-page {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
